import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

import useContext from "../../../context";

export default function CreditRatingSelect() {
  const [context, updateContext] = useContext();

  const isNewContract = context.contractType === 'new';

  return (
    <div className="quoteform__input-group">
      <div className="quoteform__heading">Optional—Credit Check</div>
      <div className="quoteform__text">Share your credit score with us to qualify for potential savings.</div>
      <div className="quoteform__input">
        <TextField
          id="quote-tool-creditrating"
          select
          fullWidth
          label="Credit Score"
          value={context.creditRating}
          onChange={({ target: { value } }) => updateContext((ctx) => {
            ctx.creditRating = value;

            return ctx;
          })}
          variant="outlined"
        >
          <MenuItem value="-1">Select One</MenuItem>
          <MenuItem value="600">Fair (600-649)&nbsp;{isNewContract && (<small>20% down payment</small>)}</MenuItem>
          <MenuItem value="650">Good (650-699)&nbsp;{isNewContract && (<small>10% down payment</small>)}</MenuItem>
          <MenuItem value="700">Great (700-799)&nbsp;{isNewContract && (<small>10% down payment</small>)}</MenuItem>
          <MenuItem value="800">Excellent (800+)&nbsp;{isNewContract && (<small>5% down payment</small>)}</MenuItem>
        </TextField>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanOptions/components/CreditRatingSelect.js